import React, { useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import { ReactSVG } from "react-svg";
import microsoftIcon from "../../Asset/microsoft icon.svg";
import playStore from "../../Asset/paly store.svg";
import appStore from "../../Asset/AppStoreDownload.png";
import macAppStore from "../../Asset/DownloadForMac.png";
import { MAC_APP_STORE_URL } from "../../hooks/useSmartDownload";
import IconMarquee from "../../component/marquee/Marquee";
import DownloadBanner from "./downloadBanner";
import DownloadVideoSection from "./downloadVideoSection";
import Feature from "./feature";
import { ShinyText } from "../Home/Home";
import Footer from "../../component/Footer/Footer";
import ContactUs from "../../component/contact-Us/ContactUs";
import { trackEvent } from "../../lib/mixpanel";
import { useDownload } from "../DownloadWindow/DownloadContext";

const Download = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { openInstallModal } = useDownload();
  // A click on a store/installer link — not an install. On Android/Windows
  // `app_installed` means the app really was installed, so this must not
  // share that name or cross-platform install funnels count web clicks.
  const trackInstallClick = (platform) => {
    trackEvent(
      "app_install_clicked",
      { source_page: "download", platform },
      { beforeNavigation: true }
    );
  };

  return (
    <>
      <div className="bg-white  flex flex-col gap-20 max-w-screen-2xl mx-auto overflow-hidden ">
        <Navbar />
        <div className=" flex flex-col xl:gap-20 lg:gap-16 gap-12  md:pt-36 pt-20 mt-6 md:mt-0 pb-16 z-10 relative ">
          <div className=" flex md:flex-row flex-col items-center md:gap-3 gap-10 md:mx-[5%] mx-[2%]">
            <div className="flex-1 flex md:items-start items-center justify-center flex-col gap-5 ">
              <span className="text-sm font-inter font-semibold flex justify-start items-center rounded-full  bg-[#EBF7FE] w-max  py-3 px-6">
                <span className="bg-gradient-to-r from-[#5ECCFF] to-[#407BFF] bg-clip-text text-transparent">
                  Zero Effort, Full Speed.
                </span>
              </span>
              <h1 className="xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] md:text-left text-center font-jakarta font-bold leading-tight ">
                Grab Zero Typing for <ShinyText text="iOS, Android, and Windows " />
                today.
              </h1>
              <p className="xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] md:text-left text-center font-inter font-medium text-[#636363]">
                Experience unmatched speed and accuracy in voice{" "}
                <br className="lg:flex hidden" /> dictation. Now on iOS, Windows, and
                Android.
              </p>
              <div className=" flex flex-wrap items-center justify-center md:justify-start gap-3 font-inter">
                <a
                  href="https://zerotyping.ai/ztaupdate/ZeroTypingAI.msi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={() => {
                    trackInstallClick("windows");
                    openInstallModal("windows");
                  }}
                >
                  <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-2 px-4 rounded-lg">
                    <ReactSVG
                      src={microsoftIcon}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-[2rem] h-[2rem]");
                      }}
                    />
                    <div className=" flex flex-col items-start">
                      <span className=" text-[.6rem]">Download for</span>
                      <span className=" font-semibold">Windows</span>
                    </div>
                  </button>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=ai.zerotyping"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={() => trackInstallClick("android")}
                >
                  <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-2 px-4 rounded-lg">
                    <ReactSVG
                      src={playStore}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-[2rem] h-[2rem]");
                      }}
                    />
                    <div className=" flex flex-col items-start">
                      <span className=" text-[.6rem]">GET IT ON</span>
                      <span className=" font-semibold">Google Play</span>
                    </div>
                  </button>
                </a>

                <a
                  href="https://apps.apple.com/us/app/zero-typing-ai-voice-to-text/id6752406283"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={() => trackInstallClick("ios")}
                >
                  <img
                    src={appStore}
                    alt="Download on the App Store"
                    className="h-[52px] w-auto rounded-lg cursor-pointer"
                  />
                </a>

                <a
                  href={MAC_APP_STORE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={() => trackInstallClick("mac")}
                >
                  <img
                    src={macAppStore}
                    alt="Download for MacOS on the Mac App Store"
                    className="h-[52px] w-auto rounded-lg cursor-pointer object-contain"
                  />
                </a>
              </div>
            </div>

            <div className="flex-1 relative flex justify-end ">
              <div className=" lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl shadow-none overflow-hidden">
                <video
                  className=" w-full scale-105 "
                  src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/Download%20Page%20Animation1(1).mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  webkit-playsinline="true"
                  preload="metadata"
                />
              </div>
            </div>
          </div>
          <IconMarquee text="Connect with Any App You Love" />
          <DownloadBanner setIsOpen={setIsOpen} />
          <DownloadVideoSection />
          <Feature />
        </div>
      </div>
      <Footer />
      <ContactUs isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default Download;
